import { Injectable } from '@angular/core';

import { FsTransferService } from '@firestitch/transfer';
import { FsApi, RequestConfig } from '@firestitch/api';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';


@Injectable({
  providedIn: 'root',
})
export class AssetData {

  constructor(
    private _api: FsApi,
    private _transfer: FsTransferService,
  ) { }

  public create(data = { id: null }) {
    return data;
  }

  public get(assetId: number | string, query = {}): Observable<any> {
    return this._api.get(`assets/${assetId}`, query, { key: 'asset' });
  }

  public gets(data = {}, config: RequestConfig = {}): Observable<any> {
    return this._api.request('GET', 'assets', data, { key: 'assets', ...config });
  }

  public put(asset, config: RequestConfig = {}): Observable<any> {
    return this._api
      .put(`assets/${asset.id}`, asset, { key: 'asset', ...({ ...config }) });
  }

  public order(data, config: RequestConfig = {}): Observable<any> {
    return this._api.put('assets/order', data, { key: null, ...config });
  }

  public post(asset): Observable<any> {
    let url = 'assets';
    if (asset.id && asset.file && asset.file instanceof File) {
      url += `/${asset.id}`;
    }

    return this._api.post(url, asset, { key: 'asset' })
      .pipe(
        map((response) => {
          return response;
        }),
      );
  }

  public delete(asset): Observable<any> {
    return this._api.delete(`assets/${asset.id}`, asset, { key: 'asset' });
  }

  public bulkDelete(data): Observable<any> {
    return this._api.delete('assets/bulk', data, { key: 'assets' });
  }

  public save(data): Observable<any> {
    if (data.id) {
      return this.put(data);
    }

    return this.post(data);
  }

  public download(asset): void {
    this._transfer.post(`assets/${asset.id}/download`);
  }

  public export(asset): void {
    this._transfer.post(`assets/${asset.id}/export`);
  }

}
